import React, { useState } from 'react';
import { Copy, Check } from '@/ui/svg';
import { writeTextToClipboard } from '@/utils';

export default function CopyText({
  content = '',
  className,
}: {
  content?: string;
  className?: string;
}) {
  const [copied, setCopied] = useState(false);
  return (
    <div
      className="cursor-pointer flex-shrink-0"
      onClick={async () => {
        if (!copied) {
          writeTextToClipboard(content, () => {
            setCopied(true);
            setTimeout(() => {
              setCopied(false);
            }, 3000);
          });
        }
      }}
    >
      {copied ? (
        <Check className="text-green-accent" />
      ) : (
        <Copy className={className} />
      )}
    </div>
  );
}
